export enum VideoSyncType {
  Audio = 'Audio',
  Gameplay = 'Gameplay',
}
